import { IAction } from 'types/storeTypes'

interface ICfdState {
    sendToCFS: boolean
}

const initialState: ICfdState = {
    sendToCFS: false,
}

function cfdReducer(
    state: ICfdState = initialState,
    action: IAction,
): ICfdState {
    const { payload, type } = action
    switch (type) {
        case 'SET_SEND_TO_CFS': {
            return {
                ...state,
                sendToCFS: payload,
            }
        }
        default:
            return state
    }
}

export default cfdReducer
